import { fetch, buildQueryString } from '../utils/request';

const ASSETS_BASE = process.env.ASSET_MANAGER_API;

// get paginated assets
export const getAssets = async (userId, query) => {
  const queryString = buildQueryString(query);
  const url = `${ASSETS_BASE}/v2/assets/${userId}${queryString}`;
  return fetch(url);
};

export const getAsset = async (assetId) => fetch(`${ASSETS_BASE}/v2/asset/${assetId}`);

export const getDirectory = async (id) => fetch(`${ASSETS_BASE}/v2/directory/${id}?includeParentTree=true`);

export const getPresignedUrl = async (owner, params) => {
  const {
    filename,
    contentType,
    type,
  } = params;

  return fetch(`${ASSETS_BASE}/upload/${owner}?filename=${encodeURIComponent(filename)}&type=${type}&contentType=${encodeURIComponent(contentType)}`);
};

export const createAsset = async (params) => fetch(`${ASSETS_BASE}/v2/asset`, {
  method: 'POST',
  headers: {
    'content-type': 'application/json',
  },
  body: JSON.stringify(params),
});
